import { render } from "./login.vue?vue&type=template&id=134681fd"
import script from "./login.js?vue&type=script&lang=js&external"
export * from "./login.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__